module.exports = __webpack_public_path__ + "static/media/8.2f243d5c.jpg";